import Label from "components/Label/Label";
import React, { useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import userApis from "apis/users";
import { toast } from "react-toastify";
import { DEMO_STAY_LISTINGS } from "data/listings";
import moment from "moment";
import { setLoading } from "features/auth";

const AccountPage = ({ className = "" }) => {
  const token = useSelector((state) => state.auth?.jwt);
  const dispatch = useDispatch();
  const api = new userApis(token);
  const [orders, setOrders] = useState([]);

  const handleFetchOrders = async () => {
    try {
      dispatch(setLoading(true));
      const ordersResponse = await api.getOrders();
      setOrders(ordersResponse);
      dispatch(setLoading(false));
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    handleFetchOrders();
  }, []);
  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Account || Booking React Template</title>
      </Helmet>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Booking infomation</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          {orders.map((item) => (
            <div
              key={item.id}
              className="border border-gray-300 rounded-lg shadow-md p-4 bg-white"
            >
              <p className="text-sm text-gray-600">
                Date: {moment(item.date)?.format("DD MMM")}
              </p>
              <p className="text-sm text-gray-600">
                Slot:{" "}
                {
                  DEMO_STAY_LISTINGS.find(
                    // Removed Number() conversion
                    (listing) => listing.id === item.placeId
                  )?.slots[item.slot]?.name
                }
              </p>
              <p className="text-sm text-gray-600">Price: {item.price}</p>
              <p className="text-sm text-gray-600">
                Place Name:{" "}
                {
                  DEMO_STAY_LISTINGS.find(
                    // Removed Number() conversion
                    (listing) => listing.id === item.placeId
                  )?.title
                }
              </p>
              <p
                className={`text-sm font-bold ${
                  // item.status === "booked" ?
                  "text-green-500"
                  // : item.status === "payment failed"
                  // ? "text-red-500"
                  // : "text-blue-500"
                }`}
              >
                Status: {"booked"}
              </p>
              <button
                className="mt-4 px-4 py-2 text-white bg-blue-500 hover:bg-blue-600 rounded-lg"
                onClick={() => alert(`Clicked card ID: ${item.id}`)}
              >
                Refund
              </button>
            </div>
          ))}
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPage;
